import { RouteConfig } from 'shared/types/route';
import * as routePaths from 'shared/constants/routePaths';

import WorkflowListView from 'pages/workflow-list/WorkflowListView';
import CreateWorkflowForm from 'pages/workflow-creation/CreateWorkflowModalForm';
import EditWorkflowForm from 'pages/workflow-editing/WorkflowEditForm';
import { NotFoundPage } from 'services/routes/NotFoundPage';

const routes: RouteConfig[] = [
  {
    component: WorkflowListView,
    name: 'workflow-list',
    path: routePaths.WORKFLOWS_PATH,
    exact: true,
  },
  {
    component: CreateWorkflowForm,
    name: 'create-workflow',
    path: routePaths.CREATE_WORKFLOW_PATH,
    exact: true,
  },
  {
    component: EditWorkflowForm,
    name: 'edit-workflow',
    path: `${routePaths.EDIT_WORKFLOW_PATH}/:workflowGuid`,
    exact: true,
  },
  {
    component: NotFoundPage,
    name: '404',
    path: '*',
  },
];

export default routes;
